import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function OfferSection() {
  return <section id="compra" className="py-20 px-4 max-w-4xl mx-auto scroll-mt-20" data-id="element-145">
      <div className="glass-card rounded-3xl p-8 md:p-12 border-2 border-brand-gold relative overflow-hidden" data-id="element-146">
        {/* Shine effect */}
        <div className="absolute top-0 -left-[100%] w-1/2 h-full bg-gradient-to-r from-transparent via-white/10 to-transparent skew-x-[45deg] animate-[shine_3s_infinite]" data-id="element-147"></div>

        <div className="text-center mb-8" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-149">
            Resumen de tu pedido
          </h2>
          <p className="text-gray-300" data-id="element-150">Todo lo que te llevas hoy</p>
        </div>

        <div className="bg-brand-dark/80 rounded-2xl p-6 mb-8 border border-white/10" data-id="element-151">
          <ul className="space-y-3 mb-6 text-gray-300" data-id="element-152">
            <li className="flex justify-between items-center" data-id="element-153">
              <span data-id="element-154">Curso completo de italiano</span>
              <span className="text-gray-500 line-through" data-id="element-155">$15,000</span>
            </li>
            <li className="flex justify-between items-center" data-id="element-156">
              <span data-id="element-157">Módulo de pronunciación</span>
              <span className="text-gray-500 line-through" data-id="element-158">$8,000</span>
            </li>
            <li className="flex justify-between items-center" data-id="element-159">
              <span data-id="element-160">Ejercicios prácticos</span>
              <span className="text-gray-500 line-through" data-id="element-161">$5,000</span>
            </li>
            <li className="flex justify-between items-center" data-id="element-162">
              <span data-id="element-163">Material de cultura</span>
              <span className="text-gray-500 line-through" data-id="element-164">$4,000</span>
            </li>
            <li className="flex justify-between items-center text-brand-gold" data-id="element-165">
              <span data-id="element-166">🎁 Bonos exclusivos (Gratis hoy)</span>
              <span className="text-gray-500 line-through" data-id="element-167">$6,000</span>
            </li>
            <li className="flex justify-between items-center pt-4 border-t border-white/10 font-bold" data-id="element-168">
              <span data-id="element-169">Valor Total Real:</span>
              <span className="text-gray-500 line-through text-xl" data-id="element-170">
                $38,000
              </span>
            </li>
          </ul>
        </div>

        <div className="text-center mb-8" data-id="element-171">
          <p className="text-xl text-gray-400 mb-2" data-id="element-172">
            Precio anterior: <span className="line-through" data-id="element-173">$30,990 ARS</span>
          </p>
          <div className="bg-brand-gold/10 inline-block px-8 py-4 rounded-2xl border border-brand-gold/30" data-id="element-174">
            <p className="text-lg text-brand-gold font-bold mb-1" data-id="element-175">HOY SOLO:</p>
            <p className="text-5xl md:text-6xl font-bold text-white" data-id="element-176">
              $19,990 <span className="text-2xl text-brand-gold" data-id="element-177">ARS</span>
            </p>
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-178">
          <a href="https://elrincondigital.click/checkouts/cn/hWNAo7z75maXKkG1F9Tv4tAg/es-ar?_r=AQABSkl_EFQxzGD_FUgSwkK30K4-GLFlFaSWe9naqJX1U9E&preview_theme_id=154785841310" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-brand-green hover:bg-green-600 text-white font-bold text-2xl py-5 px-12 rounded-xl shadow-[0_0_30px_rgba(0,146,70,0.5)] hover:shadow-[0_0_50px_rgba(0,146,70,0.8)] transition-all transform hover:scale-105" data-id="element-179">
            👉 QUIERO ACCEDER AHORA
          </a>
          <p className="text-sm text-gray-400 mt-4" data-id="element-180">
            Pago único. Acceso de por vida.
          </p>
        </div>

        <div className="flex justify-center mb-6" data-id="element-181">
          <CountdownTimer size="md" data-id="element-182" />
        </div>
      </div>
    </section>;
}